import React from 'react';
import PropTypes from 'prop-types';
import Section from 'helpers/Section';

const HotelsSeo = ({translations: {title, body}}) => (
  <Section
    sectionClass="py-7 text-center bg-white"
  >
    <div className="w-sm-2-3 mx-auto">
      <p className="display-3 font-light">
        {title}
      </p>
      <p>
        {body}
      </p>
    </div>
  </Section>
);

HotelsSeo.propTypes = {
  translations: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  })
};

export default HotelsSeo;
